"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePlugin = void 0;
const components_1 = require("./components");
const version_1 = require("./version");
exports.BasePlugin = {
    description: 'Use React Router navigation in BlueBase apps!',
    key: '@bluebase/plugin-react-router',
    name: 'BlueBase React Router Plugin',
    version: version_1.VERSION,
    components: {
        Header: components_1.Header,
        HeaderBackButton: components_1.HeaderBackButton,
        HeaderTitle: components_1.HeaderTitle,
        Navigator: {
            applyStyles: false,
            value: components_1.Navigator,
        },
        ScreenView: {
            applyStyles: false,
            value: components_1.ScreenView,
        },
    },
};
